import React from "react";
import { useTranslation } from "react-i18next";

import { Resource } from "./resource";
import { AddMember } from "./addMember";
import { Props } from "./types";
import styles from "./styles.scss";

function ResourcesList(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.resourcesList}>
      <h3 className={styles.title}>
        {t("editResourceGroup.resourcesList.title")}
      </h3>
      <div className={styles.resourceForm}>
        <AddMember
          resources={props.resources}
          addResources={props.addResources}
          removeResources={props.removeResources}
        />
      </div>
      <div className={styles.resources}>
        {props.resources.map((resource) => (
          <div key={resource.uuid} className={styles.resource}>
            <Resource
              resource={resource}
              remove={(resource) => props.removeResources([resource])}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export { ResourcesList };
